import axios from 'axios'
import interceptorsSetup from '@/helpers/interceptors'

const baseURL = process.env.VUE_APP_API_URL_V3 + '/clientForecast'

const clientForecastAPI = axios.create({
  baseURL
})

interceptorsSetup(clientForecastAPI)

export default class clientForecast {
  static async getTable (forecastQuery) {
    const result = await clientForecastAPI.get('/', {
      params:
      {
        continent: forecastQuery.continent,
        country: forecastQuery.country,
        soldto: forecastQuery.soldto
      }
    })
    return result.data
  }
  static async createForecast (forecast) {
    const result = await clientForecastAPI.post('/', forecast)
    return result.data
  }
  static async getSoldTos () {
    const result = await clientForecastAPI.get('/soldtos')
    return result.data
  }
  static async getShipTos (soldTo) {
    const result = await clientForecastAPI.get('/shiptos/' + soldTo)
    return result.data
  }
  static async getAllShipTos () {
    const result = await clientForecastAPI.get('/shiptos')
    return result.data
  }
  static async updateForecast (forecast) {
    const result = await clientForecastAPI.post('/update', forecast)
    return result.data
  }
  static async archiveForecast (forecast) {
    const result = await clientForecastAPI.put('/archive/' + forecast)
    return result.data
  }
}
